export function getPaymentMethodLabel(
  method: string | null | undefined,
  t: (key: string) => string
): string {
  if (!method) {
    return t('checkout.paymentMethod')
  }

  const optionKey = `checkout.paymentOptions.${method}`
  const translated = t(optionKey)
  return translated === optionKey ? method : translated
}
